export interface IExerciseConfig {
  id: string;
  title: string;
  pos: number;
  mandatory?: boolean;
}

export const exercisesConfig: IExerciseConfig[] = [
  {
    id: "squat",
    title: "Squat",
    pos: 0,
    mandatory: true
  },
  {
    id: "bench",
    title: "Bench",
    pos: 1,
    mandatory: true
  },
  {
    id: "press",
    title: "Press",
    pos: 2,
    mandatory: true
  },
  {
    id: "deadlift",
    title: "Deadlift",
    pos: 3,
    mandatory: true
  },
  {
    id: "chins",
    title: "Chins",
    pos: 4,
    mandatory: true
  },
  {
    id: "lat_pulldown",
    title: "Lat Pulldown",
    pos: 5,
    mandatory: true
  },
  {
    id: "power_clean",
    title: "Power Clean",
    pos: 6,
    mandatory: true
  },
  {
    id: "barbell_rows",
    title: "Barbell Rows",
    pos: 7
  },
  {
    id: "bodyweight_row",
    title: "Bodyweight Row",
    pos: 8
  },
  {
    id: "clean",
    title: "Clean",
    pos: 9
  },
  {
    id: "clean_jerk",
    title: "Clean and Jerk",
    pos: 10
  },
  {
    id: "close_grip_bench_press",
    title: "Close Grip Bench Press",
    pos: 11
  },
  {
    id: "curls",
    title: "Curls",
    pos: 12
  },
  {
    id: "deficit_deadlift",
    title: "Deficit Deadlift",
    pos: 13
  },
  {
    id: "dips",
    title: "Dips",
    pos: 14
  },
  {
    id: "echo_bike",
    title: "Echo Bike",
    pos: 15
  },
  {
    id: "front_squat",
    title: "Front Squat",
    pos: 16
  },
  {
    id: "halting_deadlift",
    title: "Halting Deadlift",
    pos: 17
  },
  {
    id: "high_bar_squat",
    title: "High Bar Squat",
    pos: 18
  },
  {
    id: "jerk",
    title: "Jerk",
    pos: 19
  },
  {
    id: "lyingTricepExtensions",
    title: "Lying Tricep Extensions",
    pos: 20
  },
  {
    id: "paused_bench",
    title: "Paused Bench",
    pos: 21
  },
  {
    id: "paused_deadlift",
    title: "Paused Deadlift",
    pos: 22
  },
  {
    id: "paused_s",
    title: "Paused Squat",
    pos: 23
  },
  {
    id: "pin_bench_press",
    title: "Pin Bench Press",
    pos: 24
  },
  {
    id: "pin_press",
    title: "Pin Press",
    pos: 25
  },
  {
    id: "pin_squat",
    title: "Pin Squat",
    pos: 26
  },
  {
    id: "power_snatch",
    title: "Power Snatch",
    pos: 27
  },
  {
    id: "prowler",
    title: "Prowler",
    pos: 28
  },
  {
    id: "pullups",
    title: "Pullups",
    pos: 29
  },
  {
    id: "rdl",
    title: "RDL",
    pos: 30
  },
  {
    id: "rack_pull",
    title: "Rack Pull",
    pos: 31
  },
  {
    id: "snatch",
    title: "Snatch",
    pos: 32
  },
  {
    id: "snatch_grip_deadlift",
    title: "Snatch Grip Deadlift",
    pos: 33
  },
  {
    id: "stiff_legged_deadlift",
    title: "Stiff Legged Deadlift",
    pos: 34
  },
  {
    id: "strict_press",
    title: "Strict Press",
    pos: 35
  }
];
